class CollectionCardStack extends HTMLElement {
	constructor() {
		super();

		this.cards = this.querySelectorAll('.collection-card-stack__card');
		if (this.cards.length === 0) {
			return;
		}

		this.cards[0].classList.add('is-expanded');
		this.classList.add('has-expanded');

		this.cards.forEach((card) => {
			card.addEventListener('mouseenter', () => this.expandCard(card));
		});
	}

	expandCard(card) {
		this.cards.forEach((c) => c.classList.remove('is-expanded'));
		card.classList.add('is-expanded');
	}
}

if (!customElements.get('collection-card-stack')) {
	customElements.define('collection-card-stack', CollectionCardStack);
}
